"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var framework_1 = require("./../../../widgets/framework");
var GameSelection = function (_a) {
    var theme = _a.theme, games = _a.games;
    var classes = styles(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var isMobile = (0, useMediaQuery_1.default)(theme.breakpoints.down('xs'));
    var onCardClicked = function (gameId) {
        var appNavigate = {
            action: 'NUMBER_CHECKER_DETAILS',
            data: { gameId: gameId }
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    return (react_1.default.createElement(core_1.Grid, { xs: 12 },
        react_1.default.createElement(core_1.Typography, { className: classes.sectionTitle, variant: isMobile ? 'h6' : 'h4' }, t('numberChecker.selectOneGame')),
        react_1.default.createElement(core_1.List, { className: classes.gamesContainer }, games &&
            (games === null || games === void 0 ? void 0 : games.map(function (game) {
                var onSelect = function () { return onCardClicked(game.id); };
                return (react_1.default.createElement(core_1.ListItem, { className: classes.gameCard, key: game.id, onClick: onSelect },
                    react_1.default.createElement(core_1.Link, { className: classes.gameCardButton, component: "button" },
                        react_1.default.createElement("img", { src: game.image, className: classes.gameImage, alt: game.name })),
                    react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, game.name)));
            })))));
};
var styles = function (theme) {
    var _a, _b, _c, _d;
    return (0, core_1.makeStyles)({
        container: (_a = {},
            _a[theme.breakpoints.up('md')] = {
                maxWidth: '80%'
            },
            _a.display = 'flex',
            _a.flexDirection = 'column',
            _a.justifyContent = 'flex-start',
            _a.alignItems = 'center',
            _a),
        gameCard: (_b = {
                width: '238px',
                margin: "0 12px 32px",
                display: 'flex',
                flexDirection: 'column',
                padding: '0'
            },
            _b[theme.breakpoints.between('sm', 'md')] = {
                margin: '0 8px 24px'
            },
            _b[theme.breakpoints.down('sm')] = {
                width: '216px'
            },
            _b[theme.breakpoints.down('xs')] = {
                width: '164px'
            },
            _b.border = '0 !important',
            _b),
        gameCardButton: (_c = {
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                width: '238px',
                height: '153px',
                padding: '8px 16px',
                marginBottom: '8px',
                boxShadow: '0 8px 16px 0 #919eab3d',
                borderRadius: '8px'
            },
            _c[theme.breakpoints.down('sm')] = {
                width: '216px',
                height: '162px'
            },
            _c[theme.breakpoints.down('xs')] = {
                width: '164px',
                height: '106px'
            },
            _c),
        gameImage: {
            position: 'relative',
            width: '100%',
            cursor: 'pointer'
        },
        sectionTitle: {
            textAlign: 'center'
        },
        gamesContainer: (_d = {
                marginTop: '16px !important',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                width: '100%'
            },
            _d[theme.breakpoints.up(426)] = {
                justifyContent: 'flex-start',
                width: '100%',
                margin: '0 auto',
                marginLeft: theme.spacing(3)
            },
            _d[theme.breakpoints.up(1023)] = {
                justifyContent: 'center',
                width: '100%',
                margin: '0 auto'
            },
            _d[theme.breakpoints.up(1200)] = {
                justifyContent: 'center',
                width: '100%',
                margin: '0 auto'
            },
            _d)
    });
};
exports.default = GameSelection;
//# sourceMappingURL=GameSelectionV2.js.map